import React, { Component } from 'react';
import spayImages from './spayimages';
import { Link } from 'react-router-dom';

import $ from 'jquery';

class SpayNav extends Component {
    state = {
        isMenuToggled: false
    };

    componentDidMount() {
        $(function () {
            $('.nav-list > li').hover(function (e) {
                // limit click to children of mainmenu
                var $el = $('ul', this); // element to toggle
                $('.nav-list .sub-menu').not($el).slideUp(); // slide up other elements
                $el.stop(true, true).slideToggle(0); // toggle element .slideToogle(400)
                return false;
            });
            $('.nav-list > li > ul > li').hover(function (e) {
                e.stopPropagation(); // stop events from bubbling from sub menu clicks
            });
        });
    }

    handleMenuToggle = () => {
        this.setState({ isMenuToggled: !this.state.isMenuToggled });
    };

    render() {
        const { SpayClosebtn, SpayLogo, SpayMenu, SpayLogo_1, SpayArrow, SpayReadmore, SpayReadmore2, SpayReadmore3 } =
            spayImages();
        return (
            <div>
                <div className="nav-container">
                    {!navigator.onLine && (
                        <div
                            style={{
                                width: '100%',
                                height: 20,
                                display: 'flex',
                                flex: 1,
                                background: 'red',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                            <h4 style={{ fontSize: 14, fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
                                You are currently offline
                            </h4>
                        </div>
                    )}
                    <nav className={this.state.isMenuToggled ? 'main-nav active' : 'main-nav'}>
                        <div className="menu-icons" onClick={this.handleMenuToggle}>
                            <img className="menu-btn" src={SpayMenu} alt="menu btn" />
                            <img className="close-btn" src={SpayClosebtn} alt="menu btn" />
                        </div>

                        <div className="spay-logo ">
                            <Link to="/">
                                <img className="logo-1" src={SpayLogo} alt="SPay Logo" />
                            </Link>
                            <Link to="/">
                                <img className="logo-2" src={SpayLogo_1} alt="SPay Logo" />
                            </Link>
                        </div>

                        <div className="nav-list-container">
                            {/*Nav-list 1 */}
                            <ul className="nav-list">
                                {/*Our Products Nav-list */}

                                {/*<li className="main-nav-list" style={{ cursor: 'pointer' }}>
                                    <Link to="/" className="drop more-margin  scroll-font-color  pointerDisabled">
                                        Product
                                        <span>
                                            <img src={SpayArrow} alt="arrow-btn" />
                                        </span>
                                    </Link>
                                    <div className="nav-list-position">
                                        <ul className="sub-menu product-info-container ">
                                            <div className="little-dot"></div>
                                            <div className="sub-info-container">
                                                <div className="individual-list sub-info ">
                                                    <li>
                                                        <Link to="/">
                                                            <span className="dash-styling">&mdash;</span>
                                                            Individual
                                                        </Link>
                                                    </li>
                                                    <div className="product-additional-info">
                                                        <p>
                                                            Create a personal account today and start sending and
                                                            receiving money with ease.
                                                        </p>
                                                        <div className="btn">
                                                            <Link to="/">Register</Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="business-list sub-info">
                                                    <li>
                                                        <Link to="/">
                                                            <span className="dash-styling">&mdash;</span>
                                                            Businesses
                                                        </Link>
                                                    </li>
                                                    <div className="product-additional-info">
                                                        <p>You can manage multiple businesses from one dashboard.</p>
                                                        <div className="btn">
                                                            <Link to="/">Register</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ul>
                                    </div>
                                </li>*/}

                                {/*###################### */}

                                {/*<li className="main-nav-list">
                                    <Link to="/" className="scroll-font-color">
                                        Customers
                                    </Link>
                            </li>*/}
                                <li className="main-nav-list">
                                    <Link className="scroll-font-color" to="/Spay-Pricing">
                                        Pricing
                                    </Link>
                                </li>
                                <li className="main-nav-list why-margin" style={{ cursor: 'pointer' }}>
                                    <Link to="/" className=" drop  scroll-font-color  pointerDisabled">
                                        Why SPay
                                        <span>
                                            <img src={SpayArrow} alt="arrow-btn" />
                                        </span>
                                    </Link>
                                    <div className="nav-list-position">
                                        {/*Sub-Menu Start Here */}
                                        <ul className="sub-menu why-spay-info-container">
                                            <div className="little-dot-2"></div>
                                            <div className="sub-info-container">
                                                <div className="why-spay-list">
                                                    <li>
                                                        <Link to="/end-to-end">
                                                            <span className="dash-styling">&mdash;</span>
                                                            End-To-End Deployment
                                                        </Link>
                                                    </li>
                                                    <div className="why-spay-additional-info">
                                                        <p>
                                                            We give you peace of mind by ensuring a secure environment
                                                            for your transactions every time.
                                                        </p>
                                                        <div className="btn">
                                                            <div className="small-icon">
                                                                <img src={SpayReadmore} alt="Readmore" />
                                                            </div>
                                                            <div className="read-more-btn">
                                                                <Link to="/end-to-end">Read More</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="why-spay-list">
                                                    <li>
                                                        <Link to="/No-Coding">
                                                            <span className="dash-styling">&mdash;</span>
                                                            No Coding-Simple Plugins
                                                        </Link>
                                                    </li>
                                                    <div className="why-spay-additional-info">
                                                        <p>
                                                            You can integrate with us seamlessly with a simple copy and
                                                            paste.
                                                        </p>
                                                        <div className="btn">
                                                            <div className="small-icon">
                                                                <img src={SpayReadmore2} alt="Readmore" />
                                                            </div>
                                                            <div className="read-more-btn">
                                                                <Link to="/No-Coding">Read More</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="why-spay-list">
                                                    <li>
                                                        <Link to="/Payment-Simplified">
                                                            <span className="dash-styling">&mdash;</span>
                                                            Payments Simplified
                                                        </Link>
                                                    </li>
                                                    <div className="why-spay-additional-info">
                                                        <p>
                                                            We handle your payment needs while you focus on your core
                                                            business.
                                                        </p>
                                                        <div className="btn">
                                                            <div className="small-icon">
                                                                <img src={SpayReadmore3} alt="Readmore" />
                                                            </div>
                                                            <div className="read-more-btn">
                                                                <Link to="/Payment-Simplified">Read More</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ul>
                                    </div>
                                </li>

                                <li className="main-nav-list sect-1" style={{ cursor: 'pointer' }}>
                                    <Link to="/" className="drop less-margin  scroll-font-color  pointerDisabled">
                                        Developers
                                        <span>
                                            <img src={SpayArrow} alt="arrow-btn" />
                                        </span>
                                    </Link>
                                    <ul className="sub-menu sect-1 developer">
                                        <div className="little-dot sect-1 developer"></div>
                                        <li>
                                            <a href="https://spay.readme.io/docs" target="_blank" rel="noreferrer">
                                                <span className="dash-styling">&mdash;</span>
                                                Documentation
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://join.slack.com/t/spaydev/shared_invite/zt-1q8o2pxyb-I6OFixebedcXlVNFTEuksg"
                                                target="_blank"
                                                rel="noreferrer">
                                                <span className="dash-styling">&mdash;</span>
                                                Developer Community
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li className="main-nav-list sect-1">
                                    <Link to="/" className="drop more-margin scroll-font-color pointerDisabled">
                                        Support
                                        <span>
                                            <img src={SpayArrow} alt="arrow-btn" />
                                        </span>
                                    </Link>
                                    <ul className="sub-menu sect-1 sect-2 top-support">
                                        <div className="little-dot sect-1 sect-2 top-support"></div>
                                        <li>
                                            <Link to="/Spay-Help">
                                                <span className="dash-styling">&mdash;</span>
                                                SPay Help
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/">
                                                <span className="dash-styling">&mdash;</span>
                                                Community
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/Faq">
                                                <span className="dash-styling">&mdash;</span>
                                                FAQ
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/Contact">
                                                <span className="dash-styling">&mdash;</span>
                                                Contact Us
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="main-nav-list login-margin">
                                    <Link className="scroll-font-color" to="/">
                                        Login
                                    </Link>
                                </li>
                                <div className="tablet-content-divider"></div>
                                <li className="main-nav-list register-btn">
                                    <Link to="/register">Register</Link>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
                {/*Header Navigation Section | End Here */}
            </div>
        );
    }
}

export default SpayNav;
